// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__mNPqW","tab":"Tabs_tab__28Mkm","primary":"Tabs_primary__3RHl-","active":"Tabs_active__2hPHG","cycle":"Tabs_cycle__d8KE2"};